<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Recent Referrals (Last 30 Days)</strong>
      </div>
    </template>

    <table class="referrals" style="overflow-x: auto">
      <thead class="grey--text font-weight-bold text--darken-2">
      <tr >
        <td class="lmost text-center">Date</td>
        <td>Customer</td>
        <td>Service</td>
        <td>Pros</td>
      </tr>
      </thead>
      <tr v-for="request in requests" :key="request.customer_request_id">
        <td class="lmost text-center">{{ $formatters.formatDate(new Date(request.created_at)) }}</td>
        <td>
          <router-link :to="{ name: 'leads/show', params: { id: request.request_id } }">
            {{ request.customer.name }}
          </router-link>
        </td>
        <td>{{ $formatters.truncate(request.service,20) }}</td>
        <td class="text-center">{{ request.referral_count }}</td>
      </tr>
    </table>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserRequestsSection',

  props: ['user_id'],

  components: { Section },

  computed: {
    ...mapGetters('users', { requests: 'currentUserRequests'}),
  },

  methods: {
    ...mapActions('users', ['loadCurrentUserRequests']),
  },

  created() {
    this.loadCurrentUserRequests({ user_id: this.user_id })
  }
}
</script>